// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".app-header {\n  align-items: center;\n  /* background: #dcdcdc; */\n  display: flex;\n  justify-content: space-between;\n  padding: 0 2rem;\n}\n\n.app-header__logo {\n  /* background: #999; */\n  height: 25px;\n  width: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
